/* =========================================================================
   OSTOYS — interactiviteit voor de mockup
   Werkt op alle pagina's: detecteert wat aanwezig is en bindt handlers.
   Bevat: cart, wishlist, mobile menu, search dropdown, product gallery,
   filter sidebar, sort, quantity stepper, carousel, toast notifications.
   ========================================================================= */

(() => {
  'use strict';

  const $  = (sel, scope = document) => scope.querySelector(sel);
  const $$ = (sel, scope = document) => Array.from(scope.querySelectorAll(sel));

  /* ---------- product catalog (voor search dropdown) ---------- */
  const PRODUCTS = [
    { name: 'CAT graafmachine U02483', brand: 'Bruder', sku: 'U02483', price: '€ 54,76', img: 'images/products/25855-7511-home.jpg' },
    { name: 'CAT Bulldozer U02422',    brand: 'Bruder', sku: 'U02422', price: '€ 30,75', img: 'images/products/25816-7443-home.jpg' },
    { name: 'CAT Bulldozer U02443',    brand: 'Bruder', sku: 'U02443', price: '€ 24,87', img: 'images/products/25801-7452-home.jpg' },
    { name: 'CAT Asfalteerwals U02433',brand: 'Bruder', sku: 'U02433', price: '€ 18,86', img: 'images/products/25826-7489-home.jpg' },
    { name: 'CAT compacte lader U02481',brand:'Bruder', sku: 'U02481', price: '€ 18,43', img: 'images/products/25830-7502-home.jpg' },
    { name: 'Cat Mini excavator U02456',brand:'Bruder', sku: 'U02456', price: '€ 29,46', img: 'images/products/9325-5021-home.jpg' },
    { name: 'Caterpillar bulldozer U02452',brand:'Bruder', sku: 'U02452', price: '€ 62,67', img: 'images/products/7335-3440-home.jpg' },
    { name: 'Caterpillar Delta minilader',brand:'Bruder', sku: 'U02136', price: '€ 22,40', img: 'images/products/2169-2377-home.jpg' },
    { name: 'Caterpillar mobiele kraan', brand: 'Bruder', sku: 'U02445', price: '€ 38,39', img: 'images/products/330-492-home.jpg' },
    { name: 'Caterpillar verreiker',     brand: 'Bruder', sku: 'U02141', price: '€ 24,87', img: 'images/products/1987-2189-home.jpg' },
    { name: 'JCB graafmachinelader 5CX', brand: 'Bruder', sku: 'U02454', price: '€ 51,46', img: 'images/products/25819-7486-home.jpg' },
    { name: 'JCB combilader U02428',     brand: 'Bruder', sku: 'U02428', price: '€ 35,12', img: 'images/products/334-496-home.jpg' },
    { name: 'JCB midi CX combilader',    brand: 'Bruder', sku: 'U02427', price: '€ 26,31', img: 'images/products/335-497-home.jpg' },
    { name: 'JCB 2505 verreiker',        brand: 'Bruder', sku: 'U02140', price: '€ 27,37', img: 'images/products/1988-2190-home.jpg' },
    { name: 'JCB minikraan U62002',      brand: 'Bruder', sku: 'U62002', price: '€ 21,91', img: 'images/products/4263-2986-home.jpg' },
    { name: 'Bruder Graafmachine U03413',brand:'Bruder', sku: 'U03413', price: '€ 27,93', img: 'images/products/20831-7301-home.jpg' },
    { name: 'Bruder Wiellader U03412',   brand: 'Bruder', sku: 'U03412', price: '€ 28,94', img: 'images/products/20824-7292-home.jpg' },
    { name: 'Ausa Minidumper U02449',    brand: 'Bruder', sku: 'U02449', price: '€ 18,50', img: 'images/products/25822-7483-home.jpg' },
    { name: 'Fiat FR130 shovel',         brand: 'Bruder', sku: 'U02425', price: '€ 22,52', img: 'images/products/333-495-home.jpg' },
    { name: 'JD Forwarder bosbouwmachine',brand:'Bruder',sku: 'U02133', price: '€ 55,91', img: 'images/products/18481-7070-home.jpg' },
    { name: 'Claas Axion 950 (Siku)',    brand: 'Siku',   sku: 'S01949', price: '€ 30,45', img: 'images/products/4195-2918-home.jpg' },
    { name: 'Claas Axion 950 S03280',    brand: 'Siku',   sku: 'S03280', price: '€ 36,21', img: 'images/products/4219-2942-home.jpg' },
    { name: 'Claas Axion 850 1:32',      brand: 'Siku',   sku: 'S06882', price: '€ 136,78', img: 'images/products/2385-2590-home.jpg' },
    { name: 'Claas Lexion 600 combine',  brand: 'Siku',   sku: 'S01991', price: '€ 37,38', img: 'images/products/9720-5395-home.jpg' },
    { name: 'Claas 960 maishakselaar',   brand: 'Siku',   sku: 'S01993', price: '€ 28,40', img: 'images/products/7318-3493-home.jpg' },
    { name: 'Case IH Quadtrac 600',      brand: 'Siku',   sku: 'S03275', price: '€ 45,27', img: 'images/products/4218-2941-home.jpg' },
    { name: 'Balenpers John Deere 990',  brand: 'Siku',   sku: 'S02465', price: '€ 33,84', img: 'images/products/4205-2928-home.jpg' },
    { name: 'Amazone Centaur strooier',  brand: 'Siku',   sku: 'S02069', price: '€ 39,61', img: 'images/products/20795-7274-home.jpg' },
    { name: 'Deutz Agrotron X720',       brand: 'Siku',   sku: 'S01848', price: '€ 24,98', img: 'images/products/250-413-home.jpg' },
    { name: 'Aanhangwagen Joskin tandem', brand: 'Siku',  sku: 'S06780', price: '€ 93,68', img: 'images/products/1118-1310-home.jpg' },
    { name: '2-zijdige Kipper Fortuna',  brand: 'Siku',   sku: 'S06781', price: '€ 100,63', img: 'images/products/1119-1311-home.jpg' },
    { name: 'Achtermaaier Kuhn',         brand: 'Siku',   sku: 'S02456', price: '€ 16,22', img: 'images/products/1131-1323-home.jpg' },
    { name: 'Bluetooth afstandsbediening', brand: 'Siku', sku: 'S06730', price: '€ 55,50', img: 'images/products/12378-6542-home.jpg' },
    { name: 'Bosbouwset Siku',           brand: 'Siku',   sku: 'S05605', price: '€ 31,49', img: 'images/products/10890-6046-home.jpg' },
    { name: '5er-geschenk set agriculture', brand: 'Siku', sku: 'S06286', price: '€ 11,61', img: 'images/products/22633-7337-home.jpg' },
    { name: 'Cadeauset landbouw',        brand: 'Siku',   sku: 'S06304', price: '€ 16,22', img: 'images/products/7653-3697-home.jpg' },
    { name: 'Combine John Deere',        brand: 'Siku',   sku: 'S01876', price: '€ 26,09', img: 'images/products/1207-1397-home.jpg' },
    { name: 'Deutz universele strooier', brand: 'Siku',   sku: 'S01673', price: '€ 8,67',  img: 'images/products/8600-4535-home.jpg' },
  ];

  const fmtPrice = n => '€ ' + n.toFixed(2).replace('.', ',');
  const parsePrice = txt => parseFloat(String(txt).replace(/[^\d,.-]/g, '').replace(',', '.')) || 0;

  /* ============================ TOAST ============================ */
  function toast(msg, opts = {}) {
    const el = document.createElement('div');
    el.className = 'os-toast os-toast-' + (opts.type || 'success');
    el.innerHTML = `<span class="os-toast-icon">${opts.type === 'error' ? '!' : opts.type === 'info' ? 'i' : '✓'}</span><span>${msg}</span>`;
    document.body.appendChild(el);
    requestAnimationFrame(() => el.classList.add('show'));
    setTimeout(() => {
      el.classList.remove('show');
      setTimeout(() => el.remove(), 300);
    }, 2800);
  }

  /* ============================ CART (Shopify Ajax) ============================ */
  const Cart = {
    _state: null,           // gecachte cart object van /cart.js
    _listeners: [],
    on(fn) { this._listeners.push(fn); },
    notify() { this._listeners.forEach(fn => fn(this._state)); },

    async fetch () {
      try {
        const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
        this._state = await r.json();
        this.updateUI();
        this.notify();
        return this._state;
      } catch (e) { return null; }
    },

    async addVariant (variantId, qty = 1) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      });
      if (!r.ok) throw new Error((await r.json()).description || 'Toevoegen mislukt');
      await this.fetch();
    },

    async changeLine (line, qty) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      });
      await this.fetch();
    },

    async clear () {
      await fetch('/cart/clear.js', { method: 'POST' });
      await this.fetch();
    },

    get items () { return (this._state && this._state.items) || []; },
    get count () { return (this._state && this._state.item_count) || 0; },
    get total () { return (this._state && this._state.total_price) || 0; },

    updateUI () {
      const c = this.count;
      $$('[data-cart-count]').forEach(el => {
        el.textContent = c;
        el.setAttribute('data-cart-count', c);
        // Badge ALTIJD zichtbaar — toont ook "0", net als de local design
        el.classList.remove('hidden');
      });
    }
  };
  // Initial fetch
  Cart.fetch();

  /* ============================ WISHLIST ============================ */
  const Wishlist = {
    _listeners: [],
    on(fn) { this._listeners.push(fn); },
    notify() { this._listeners.forEach(fn => fn()); },

    get()  {
      try {
        const raw = JSON.parse(localStorage.getItem('os-wishlist') || '[]');
        // Backwards compat: oude opslag was array van strings → bouw minimal objects
        return raw.map(x => typeof x === 'string' ? { sku: x, title: x } : x);
      } catch { return []; }
    },
    set(items) {
      localStorage.setItem('os-wishlist', JSON.stringify(items));
      this.updateUI();
      this.notify();
    },
    /* item = { sku, title, vendor, url, image, price } */
    toggle(item) {
      if (!item || !item.sku) return false;
      const list = this.get();
      const idx = list.findIndex(x => x.sku === item.sku);
      if (idx >= 0) list.splice(idx, 1);
      else list.push(item);
      this.set(list);
      return idx < 0; // true = nu toegevoegd
    },
    has(sku) { return this.get().some(x => x.sku === sku); },
    remove(sku) {
      const list = this.get().filter(x => x.sku !== sku);
      this.set(list);
    },
    updateUI() {
      const n = this.get().length;
      $$('[data-wishlist-count]').forEach(el => el.textContent = n);
      $$('.wishlist-btn').forEach(b => b.classList.toggle('is-active', this.has(b.dataset.sku)));
    }
  };

  /* ============== productinfo uit een card extracten ============== */
  function readCard(card) {
    const skuLine = (card.querySelector('.uppercase')?.textContent || '').trim();
    const parts = skuLine.split('·').map(s => s.trim());
    const brand = parts[0] || '';
    const sku = parts[1] || '';
    const name = (card.querySelector('h3')?.textContent || '').trim();
    const img = card.querySelector('img')?.getAttribute('src') || '';
    const priceEl = card.querySelector('.font-display.text-os-orange, .text-os-orange.font-display, .font-display.text-os-navy, .font-display');
    const price = parsePrice(priceEl?.textContent || '0');
    return { brand, sku, name, img, price };
  }

  /* ============================ CART BUTTONS (Shopify Ajax) ============================ */
  function initCartButtons() {
    // + buttons in product cards — gebruikt data-variant-id van de card
    $$('.card-product').forEach(card => {
      const btn = card.querySelector('button[aria-label*="inkelwagen" i]');
      if (!btn) return;
      btn.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = card.getAttribute('data-variant-id');
        const title     = card.getAttribute('data-product-title') || 'Product';
        if (!variantId) return;
        try {
          btn.disabled = true;
          await Cart.addVariant(variantId, 1);
          pulseCart();
          toast(`${title} toegevoegd`);
        } catch (err) {
          toast(err.message || 'Toevoegen mislukt', { type: 'error' });
        } finally {
          btn.disabled = false;
        }
      });
    });

    /* Elk Shopify cart-add formulier (action eindigt op /cart/add) wordt Ajax-submitted.
       Geen native page-redirect na add → user blijft op productpage, cart-dropdown opent. */
    $$('form[action$="/cart/add"], form.os-cart-add-form').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const fd = new FormData(form);
        const variantId = fd.get('id');
        const qty       = parseInt(fd.get('quantity'), 10) || 1;
        if (!variantId) return;
        const submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
        const orig = submitBtn ? submitBtn.textContent : '';
        try {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Toevoegen…'; }
          await Cart.addVariant(variantId, qty);
          pulseCart();
          toast(`${qty}× toegevoegd`);
        } catch (err) {
          toast(err.message || 'Toevoegen mislukt', { type: 'error' });
        } finally {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = orig; }
        }
      });
    });
  }

  function pulseCart() {
    $$('[data-cart-count]').forEach(el => {
      el.classList.remove('cart-pulse');
      void el.offsetWidth;
      el.classList.add('cart-pulse');
    });
  }

  /* ============================ WISHLIST BUTTONS ============================ */
  function initWishlistButtons() {
    // Heart-knoppen op product cards (en op productdetail naast In winkelwagen)
    $$('.wishlist-btn').forEach(btn => {
      const sku = btn.dataset.sku;
      if (!sku) return;
      // Initiële state
      if (Wishlist.has(sku)) btn.classList.add('is-active');
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const item = {
          sku:    sku,
          title:  btn.dataset.title  || 'Product',
          vendor: btn.dataset.vendor || '',
          url:    btn.dataset.url    || '#',
          image:  btn.dataset.image  || '',
          price:  parseInt(btn.dataset.price || '0', 10)
        };
        const added = Wishlist.toggle(item);
        btn.classList.toggle('is-active', added);
        toast(added ? `${item.title} toegevoegd aan verlanglijst` : `${item.title} uit verlanglijst`, { type: added ? 'success' : 'info' });
      });
    });

    Wishlist.updateUI();
  }

  /* ============================ WISHLIST DROPDOWN ============================ */
  function initWishlistDropdown() {
    const toggle = $('#wishlist-toggle') || $('a[aria-label="Wishlist"]');
    if (!toggle) return;
    const header = toggle.closest('header');
    if (!header) return;

    let dropdown = $('.wishlist-dropdown', header);
    let overlay  = $('.wishlist-dropdown-overlay');
    if (!dropdown) {
      dropdown = document.createElement('div');
      dropdown.className = 'cart-dropdown wishlist-dropdown';
      header.appendChild(dropdown);
    }
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'cart-dropdown-overlay wishlist-dropdown-overlay';
      document.body.appendChild(overlay);
    }

    function render () {
      const items = Wishlist.get();
      if (items.length === 0) {
        dropdown.innerHTML = `
          <div class="cart-dropdown-header">
            <span>Verlanglijst</span>
            <button class="close" aria-label="Sluit">&times;</button>
          </div>
          <div class="cart-empty">
            <div class="icon">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
            </div>
            <div class="title">Je verlanglijst is leeg</div>
            <div class="sub">Klik op het hartje van een product om 'm hier op te slaan.</div>
            <a href="/collections/all" class="btn btn-orange">Naar de winkel</a>
          </div>`;
      } else {
        dropdown.innerHTML = `
          <div class="cart-dropdown-header">
            <span>Verlanglijst (${items.length})</span>
            <button class="close" aria-label="Sluit">&times;</button>
          </div>
          <div class="cart-dropdown-items">
            ${items.map(item => `
              <div class="cart-item">
                <a href="${item.url}" class="cart-item-img"><img src="${item.image || ''}" alt=""></a>
                <div class="cart-item-info">
                  <div class="cart-item-brand">${item.vendor || ''} ${item.sku ? '· ' + item.sku : ''}</div>
                  <a href="${item.url}" class="cart-item-name">${item.title}</a>
                  <div class="cart-item-bottom">
                    <a href="${item.url}" class="text-xs underline text-os-orange font-bold">Bekijk product →</a>
                    <div class="cart-item-price">${fmtPrice((item.price || 0) / 100)}</div>
                  </div>
                  <button data-act="rm" data-sku="${item.sku}" class="cart-item-remove">Verwijderen</button>
                </div>
              </div>`).join('')}
          </div>
          <div class="cart-dropdown-footer">
            <div class="cart-actions">
              <button type="button" class="btn btn-outline" data-act="clear-all">Wis alles</button>
              <a href="/collections/all" class="btn btn-orange">Verder shoppen →</a>
            </div>
          </div>`;
      }

      $('.close', dropdown)?.addEventListener('click', hide);
      $$('button[data-act="rm"]', dropdown).forEach(b => {
        b.addEventListener('click', () => {
          Wishlist.remove(b.dataset.sku);
          render();
          toast('Uit verlanglijst verwijderd', { type: 'info' });
        });
      });
      $('button[data-act="clear-all"]', dropdown)?.addEventListener('click', () => {
        Wishlist.set([]);
        render();
        toast('Verlanglijst gewist', { type: 'info' });
      });
    }

    function show () { render(); dropdown.classList.add('show'); overlay.classList.add('show'); }
    function hide () { dropdown.classList.remove('show'); overlay.classList.remove('show'); }
    function tg   () { dropdown.classList.contains('show') ? hide() : show(); }

    toggle.addEventListener('click', e => { e.preventDefault(); tg(); });

    let hoverTimer = null;
    function clearHover () { if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; } }
    toggle.addEventListener('mouseenter', () => { clearHover(); show(); });
    toggle.addEventListener('mouseleave', () => { hoverTimer = setTimeout(hide, 300); });
    dropdown.addEventListener('mouseenter', clearHover);
    dropdown.addEventListener('mouseleave', () => { hoverTimer = setTimeout(hide, 300); });

    overlay.addEventListener('click', hide);

    Wishlist.on(() => { if (dropdown.classList.contains('show')) render(); });
  }

  /* ============================ SEARCH DROPDOWN (Shopify Predictive) ============================ */
  function initSearch() {
    const SUGGEST_URL = (window.routes && window.routes.predictive_search_url) || '/search/suggest.json';

    $$('input[type="search"]').forEach(input => {
      // Skip filter-side search ("zoek binnen tractoren")
      if (input.closest('aside')) return initFilterSearch(input);

      const wrapper = input.closest('form') || input.parentElement;
      wrapper.style.position = wrapper.style.position || 'relative';
      const dropdown = document.createElement('div');
      dropdown.className = 'os-search-dropdown';
      wrapper.appendChild(dropdown);

      let timer, lastQ = '';
      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => render(input.value.trim()), 200);
      });
      input.addEventListener('focus', () => { if (input.value.trim().length >= 2) render(input.value.trim()); });
      document.addEventListener('click', e => {
        if (!wrapper.contains(e.target)) dropdown.classList.remove('show');
      });

      function highlight (text, q) {
        if (!q) return text;
        const re = new RegExp(`(${q.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')})`, 'ig');
        return text.replace(re, '<span class="os-search-mark">$1</span>');
      }

      async function render (q) {
        if (q.length < 2) { dropdown.classList.remove('show'); return; }
        if (q === lastQ) { dropdown.classList.add('show'); return; }
        lastQ = q;

        let products = [];
        try {
          const url = `${SUGGEST_URL}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const r = await fetch(url, { headers: { 'Accept': 'application/json' }});
          if (r.ok) {
            const data = await r.json();
            products = (data.resources && data.resources.results && data.resources.results.products) || [];
          }
        } catch (e) { /* silent */ }

        if (q !== input.value.trim()) return; // user typed verder ondertussen

        if (products.length === 0) {
          dropdown.innerHTML = `<div class="os-search-empty">Geen resultaten voor <strong>"${q}"</strong>.<br><small>Probeer eens: Bruder, CAT, JCB, Siku, Claas, Fendt…</small></div>`;
        } else {
          dropdown.innerHTML = products.map(p => {
            const img = p.image || (p.featured_image && p.featured_image.url) || '';
            const vendor = p.vendor || '';
            const sku = (p.variants && p.variants[0] && p.variants[0].sku) || '';
            const priceCents = (p.variants && p.variants[0] && p.variants[0].price) || p.price || 0;
            const price = fmtPrice((typeof priceCents === 'number' ? priceCents / 100 : parseFloat(priceCents) || 0));
            return `
              <a href="${p.url}" class="os-search-item">
                <img src="${img}" alt="">
                <div class="os-search-meta">
                  <div class="os-search-brand">${vendor}${sku ? ' · ' + sku : ''}</div>
                  <div class="os-search-name">${highlight(p.title, q)}</div>
                </div>
                <div class="os-search-price">${price}</div>
              </a>`;
          }).join('') + `<a href="/search?q=${encodeURIComponent(q)}" class="os-search-all">Alle resultaten voor "${q}" →</a>`;
        }
        dropdown.classList.add('show');
      }
    });
  }

  /* ============================ GALLERY (product.html) ============================ */
  function initGallery() {
    const main = document.querySelector('.flex-1.aspect-square img');
    if (!main) return;

    // Thumbs in linker kolom + mobile carousel
    const thumbs = $$('button[aria-label^="Foto"], .snap-card');
    if (!thumbs.length) return;

    thumbs.forEach((thumb, idx) => {
      thumb.classList.add('gallery-thumb');
      if (idx === 0) thumb.classList.add('is-active');
      const img = thumb.querySelector('img');
      if (!img) return;
      thumb.addEventListener('click', e => {
        e.preventDefault();
        // Update main image with fade
        main.style.opacity = '0';
        setTimeout(() => {
          main.src = img.src;
          main.style.opacity = '1';
        }, 150);
        // Active state
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
    main.style.transition = 'opacity .2s ease';
  }

  /* ============================ MOBILE FILTER TOGGLE ============================ */
  function initMobileFilterToggle() {
    const aside = $('aside');
    if (!aside || !$$('.card-product').length) return;
    if (!aside.querySelector('input[type="checkbox"], input[type="search"], input[type="number"]')) return;

    aside.classList.add('filter-aside');

    // Maak knop, plaats vóór de grid section
    const sortRow = $('select')?.closest('.flex');
    const insertTarget = sortRow || $$('.grid').find(g => g.querySelectorAll('.card-product').length >= 4);
    if (!insertTarget) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'filter-mobile-btn lg:hidden';
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg> Filter producten';
    insertTarget.parentElement.insertBefore(btn, insertTarget);

    // Close-knop in aside
    const close = document.createElement('div');
    close.className = 'filter-mobile-close lg:hidden';
    close.innerHTML = '<div class="font-display text-lg">Filters</div><button class="text-3xl leading-none" aria-label="Sluit">&times;</button>';
    aside.insertBefore(close, aside.firstChild);

    function open()  { aside.classList.add('open');  document.body.classList.add('filter-open'); }
    function hide()  { aside.classList.remove('open'); document.body.classList.remove('filter-open'); }

    btn.addEventListener('click', open);
    close.querySelector('button').addEventListener('click', hide);

    // Toon resultaat-knop onderaan (alleen op mobiel)
    const applyBtn = document.createElement('button');
    applyBtn.type = 'button';
    applyBtn.className = 'btn btn-orange w-full mt-6 lg:hidden';
    applyBtn.textContent = 'Toon resultaten';
    applyBtn.addEventListener('click', hide);
    aside.appendChild(applyBtn);

    // Tap buiten aside om te sluiten
    document.addEventListener('click', e => {
      if (aside.classList.contains('open') &&
          !aside.contains(e.target) &&
          !btn.contains(e.target)) {
        hide();
      }
    });
  }

  /* ============================ FILTERS (categorie.html + nieuw + aanbieding) ============================ */
  function initFilters() {
    // Vind het productraster — meestal de eerste grid binnen <section> die kaarten bevat
    const grids = $$('.grid').filter(g => g.querySelectorAll('.card-product').length >= 4);
    if (!grids.length) return;
    const grid = grids.find(g => g.closest('aside') === null) || grids[0];
    const cards = $$('.card-product', grid);
    if (!cards.length) return;

    // Annoteer kaarten
    cards.forEach(card => {
      const info = readCard(card);
      card.dataset.brand = info.brand.toLowerCase();
      card.dataset.sku = info.sku;
      card.dataset.price = info.price;
      card.dataset.name = info.name.toLowerCase();
    });

    function applyFilters() {
      // Brand checkboxes — gebruik labeltekst
      const brandLabels = $$('aside label').filter(l => /^(bruder|siku|universal hobbies|wiking|rolly toys|britains|schuco|kidsglobe)/i.test(l.textContent.trim()));
      const checkedBrands = brandLabels
        .filter(l => l.querySelector('input[type="checkbox"]:checked'))
        .map(l => l.textContent.replace(/\d+/g, '').trim().toLowerCase().split(' ')[0]);
      const anyBrandChecked = brandLabels.some(l => l.querySelector('input[type="checkbox"]:checked'));

      // Beschikbaarheid checkboxes — als niets gecheckt, alles. Anders alleen "op voorraad".
      // Vereenvoudiging: laat alles altijd zien op beschikbaarheid.

      // Prijs
      const priceInputs = $$('aside input[type="number"]');
      const min = parseFloat(priceInputs[0]?.value) || 0;
      const max = parseFloat(priceInputs[1]?.value) || Infinity;

      let shown = 0;
      cards.forEach(card => {
        const matchBrand = !anyBrandChecked || checkedBrands.some(b => card.dataset.brand.includes(b));
        const p = parseFloat(card.dataset.price) || 0;
        const matchPrice = p >= min && p <= max;
        const show = matchBrand && matchPrice;
        card.classList.toggle('is-filtered-out', !show);
        if (show) shown++;
      });

      // Counter update
      const counters = $$('[class*="grey"]').filter(el => /toont .* van .* producten/i.test(el.textContent));
      counters.forEach(c => {
        const orig = c.dataset.origText || (c.dataset.origText = c.innerHTML);
        c.innerHTML = orig.replace(/Toont <[^>]+>1 — \d+<\/[^>]+>/i, `Toont <span class="font-bold text-os-navy">1 — ${shown}</span>`);
      });

      // No-results banner
      let empty = $('#filter-empty');
      if (!shown) {
        if (!empty) {
          empty = document.createElement('div');
          empty.id = 'filter-empty';
          empty.className = 'col-span-full p-10 bg-os-cream rounded-3xl text-center';
          empty.innerHTML = '<div class="font-display text-xl mb-2">Geen producten voldoen aan je filters.</div><div class="text-sm text-os-grey mb-4">Pas filters aan of wis ze allemaal.</div><button id="filter-clear" class="btn btn-orange">Wis filters</button>';
          grid.appendChild(empty);
          $('#filter-clear').addEventListener('click', clearFilters);
        }
      } else if (empty) {
        empty.remove();
      }
    }

    function clearFilters() {
      $$('aside input[type="checkbox"]').forEach(c => c.checked = false);
      $$('aside input[type="number"]').forEach(n => n.value = '');
      const searchInput = $('aside input[type="search"]');
      if (searchInput) searchInput.value = '';
      applyFilters();
      toast('Filters gewist', { type: 'info' });
    }

    // Bind inputs
    $$('aside input[type="checkbox"]').forEach(el => el.addEventListener('change', applyFilters));
    $$('aside input[type="number"]').forEach(el => el.addEventListener('input', applyFilters));
    $$('aside button').filter(b => /wis alles/i.test(b.textContent)).forEach(b => b.addEventListener('click', clearFilters));

    // X knoppen in actieve filter pills
    $$('aside .tag button').forEach(b => b.addEventListener('click', e => {
      e.preventDefault();
      const pill = b.closest('.tag');
      pill?.remove();
      // simulate: uncheck Bruder if pill text matches
      $$('aside label input[type="checkbox"]').forEach(c => {
        if (c.closest('label').textContent.toLowerCase().includes(pill?.textContent.toLowerCase().replace('×','').trim() || '')) c.checked = false;
      });
      applyFilters();
    }));
  }

  function initFilterSearch(input) {
    // Zoek binnen categorie
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const q = input.value.trim().toLowerCase();
        $$('.card-product').forEach(card => {
          if (!card.dataset.name) {
            const info = readCard(card);
            card.dataset.name = info.name.toLowerCase();
          }
          card.classList.toggle('is-filtered-out', q.length > 1 && !card.dataset.name.includes(q));
        });
      }, 120);
    });
  }

  /* ============================ SORT ============================ */
  function initSort() {
    const selects = $$('select').filter(s =>
      Array.from(s.options).some(o => /aanbevolen|nieuwste|prijs|beoordeeld|korting|uitverkocht/i.test(o.textContent))
    );
    selects.forEach(sel => {
      sel.addEventListener('change', () => {
        const opt = sel.options[sel.selectedIndex].textContent.toLowerCase();
        const grid = $$('.grid').filter(g => g.querySelectorAll('.card-product').length >= 4)[0];
        if (!grid) return;
        const cards = $$('.card-product', grid);
        cards.forEach(card => {
          if (!card.dataset.price) {
            const info = readCard(card);
            card.dataset.price = info.price;
            card.dataset.name = info.name.toLowerCase();
          }
        });

        const sorted = cards.slice().sort((a, b) => {
          const pa = parseFloat(a.dataset.price) || 0;
          const pb = parseFloat(b.dataset.price) || 0;
          if (opt.includes('laag')) return pa - pb;
          if (opt.includes('hoog')) return pb - pa;
          if (opt.includes('korting') || opt.includes('nieuwste')) return Math.random() - 0.5;
          return 0;
        });

        sorted.forEach(c => grid.appendChild(c));
        toast(`Gesorteerd op "${sel.options[sel.selectedIndex].textContent}"`, { type: 'info' });
      });
    });
  }

  /* ============================ QUANTITY STEPPER ============================ */
  function initQuantity() {
    $$('input[type="number"]').forEach(input => {
      const row = input.closest('.flex.items-center');
      if (!row) return;
      const btns = row.querySelectorAll('button');
      btns.forEach(btn => {
        const sign = btn.textContent.trim();
        if (sign !== '+' && sign !== '−' && sign !== '-') return;
        btn.addEventListener('click', e => {
          e.preventDefault();
          const val = parseInt(input.value, 10) || 1;
          input.value = sign === '+' ? val + 1 : Math.max(1, val - 1);
        });
      });
    });
  }

  /* ============================ MOBILE MENU ============================ */
  function initMobileMenu() {
    // Optie 1: index.html heeft een uitgebreid mobile menu — bind daar
    const openBtn = $('#menu-open');
    if (openBtn) {
      const closeBtn = $('#menu-close');
      const overlay  = $('#menu-overlay');
      const wrap     = $('#mobile-menu-wrapper');
      const panel    = $('.mobile-menu', wrap);
      const open  = () => { wrap.style.pointerEvents = 'auto'; panel.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; };
      const close = () => { panel.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow = ''; setTimeout(() => wrap.style.pointerEvents = 'none', 300); };
      openBtn.addEventListener('click', open);
      closeBtn?.addEventListener('click', close);
      overlay?.addEventListener('click', close);
      return;
    }

    // Optie 2: andere pagina's hebben alleen een hamburger — injecteer een gedeeld menu
    const hamburger = $$('button[aria-label="Menu"]').find(b => b.querySelector('svg'));
    if (!hamburger) return;
    injectMobileMenu();
    const menu = $('#os-mobile-menu');
    const show = () => { menu.style.display = 'block'; document.body.style.overflow = 'hidden'; };
    const hide = () => { menu.style.display = 'none';  document.body.style.overflow = ''; };
    hamburger.addEventListener('click', show);
    menu.querySelector('[data-menu-overlay]').addEventListener('click', hide);
    menu.querySelector('[data-menu-close]').addEventListener('click', hide);
  }

  function injectMobileMenu() {
    if (document.getElementById('os-mobile-menu')) return;
    const menu = document.createElement('div');
    menu.id = 'os-mobile-menu';
    menu.style.cssText = 'position:fixed;inset:0;z-index:60;display:none';
    menu.innerHTML = `
      <div data-menu-overlay style="position:absolute;inset:0;background:rgba(0,0,0,.5)"></div>
      <nav style="position:absolute;top:0;right:0;width:85%;max-width:380px;height:100%;background:#fff;display:flex;flex-direction:column">
        <div style="padding:20px;border-bottom:1px solid #E5DFD3;display:flex;justify-content:space-between;align-items:center">
          <span class="logo-mark"><span class="os">OS</span><span class="toys">TOYS</span><span class="nl">.nl</span></span>
          <button data-menu-close style="font-size:28px;line-height:1;background:none;border:none;cursor:pointer">&times;</button>
        </div>
        <div style="flex:1;overflow:auto;padding:8px 0">
          <a href="categorie.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Tractoren</a>
          <a href="categorie.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Bouwmachines</a>
          <a href="categorie.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Vrachtwagens</a>
          <a href="categorie.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Landbouw</a>
          <a href="categorie.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Auto's</a>
          <a href="categorie.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">bWorld</a>
          <a href="categorie.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Accessoires</a>
          <a href="merken.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Alle merken</a>
          <a href="nieuw.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Nieuw</a>
          <a href="aanbieding.html" style="display:block;padding:14px 20px;font-weight:700;color:#F58220;border-bottom:1px solid #E5DFD3">Aanbieding</a>
          <a href="klantenservice.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Klantenservice</a>
          <a href="contact.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Contact</a>
          <a href="over-ons.html" style="display:block;padding:14px 20px;font-weight:700;border-bottom:1px solid #E5DFD3">Over ons</a>
        </div>
      </nav>`;
    document.body.appendChild(menu);
  }

  /* ============================ PAYMENT LOGOS ============================ */
  const PAYMENT_LOGOS = {
    'iDEAL':      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 18" style="height:14px"><text x="2" y="14" font-family="Arial,sans-serif" font-weight="900" font-size="16" letter-spacing="-1"><tspan fill="#0a0a0a">i</tspan><tspan fill="#CC006B">D</tspan><tspan fill="#0a0a0a">EAL</tspan></text></svg>`,
    'Bancontact': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 18" style="height:14px"><circle cx="7" cy="9" r="6" fill="#005498"/><circle cx="14" cy="9" r="6" fill="#FFD200"/><text x="24" y="13" font-family="Arial,sans-serif" font-weight="700" font-size="10" fill="#1F2D4F">Bancontact</text></svg>`,
    'PayPal':     `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 16" style="height:14px"><text x="2" y="13" font-family="Arial,sans-serif" font-weight="900" font-size="14" font-style="italic" letter-spacing="-0.5"><tspan fill="#003087">Pay</tspan><tspan fill="#009CDE">Pal</tspan></text></svg>`,
    'Klarna':     `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 26" style="height:26px"><rect width="56" height="26" rx="6" fill="#FFB3C7"/><text x="28" y="18" text-anchor="middle" font-family="Arial,sans-serif" font-weight="900" font-size="13" fill="#0a0a0a" letter-spacing="-0.5">Klarna.</text></svg>`,
    'Mastercard': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 22" style="height:16px"><circle cx="13" cy="11" r="9" fill="#EB001B"/><circle cx="23" cy="11" r="9" fill="#F79E1B"/><path d="M 18 4 a 9 9 0 0 1 0 14 a 9 9 0 0 1 0 -14" fill="#FF5F00"/></svg>`,
    'Visa':       `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 18" style="height:14px"><text x="2" y="15" font-family="Arial Black,Arial,sans-serif" font-weight="900" font-size="17" font-style="italic" fill="#1A1F71" letter-spacing="-1.5">VISA</text></svg>`
  };

  function initPaymentLogos() {
    // Zoek alleen in footer + checkout summary om "iDEAL" als gewone tekst elders niet te vervangen
    const scopes = $$('footer, #checkout-summary, [data-pay-strip]');
    scopes.forEach(scope => {
      $$('span', scope).forEach(span => {
        const txt = span.textContent.trim();
        if (PAYMENT_LOGOS[txt] && !span.querySelector('svg')) {
          span.className = 'pay-logo pay-' + txt.toLowerCase();
          span.title = txt;
          span.innerHTML = PAYMENT_LOGOS[txt];
        }
      });
    });
  }

  /* ============================ HEADER NORMALIZATION ============================ */
  // Zorg dat elke pagina exact dezelfde icons in de header heeft:
  // [Wishlist] [Cart + counter] [Mobile hamburger]
  function normalizeHeaderActions() {
    const cart = $('a[aria-label="Winkelwagen"]');
    if (!cart) return;
    cart.id = cart.id || 'cart-toggle';
    cart.classList.add('relative', 'flex', 'items-center', 'hover:text-os-orange');
    const parent = cart.parentElement;
    if (!parent) return;

    if (!parent.querySelector('a[aria-label="Wishlist"]')) {
      const wish = document.createElement('a');
      wish.href = '#';
      wish.setAttribute('aria-label', 'Wishlist');
      wish.className = 'hidden md:flex items-center hover:text-os-orange';
      wish.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      parent.insertBefore(wish, cart);
    }

    if (!parent.querySelector('button[aria-label="Menu"]')) {
      const burger = document.createElement('button');
      burger.setAttribute('aria-label', 'Menu');
      burger.className = 'lg:hidden p-2';
      burger.innerHTML = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
      parent.appendChild(burger);
    }
  }

  /* ============================ CART DROPDOWN ============================ */
  function initCartDropdown() {
    /* Probeer meerdere selectors zodat 't werkt ongeacht locale (Cart/Winkelwagen) */
    const toggle = $('#cart-toggle')
                || $('a[aria-label="Winkelwagen"]')
                || $('a[aria-label="Cart"]')
                || $('a[href$="/cart"]');
    if (!toggle) { console.warn('[OSTOYS] Cart toggle niet gevonden'); return; }
    toggle.id = toggle.id || 'cart-toggle';
    const header = toggle.closest('header');
    if (!header) return;

    let dropdown = $('.cart-dropdown', header);
    let overlay  = $('.cart-dropdown-overlay');
    if (!dropdown) {
      dropdown = document.createElement('div');
      dropdown.className = 'cart-dropdown';
      header.appendChild(dropdown);
    }
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'cart-dropdown-overlay';
      document.body.appendChild(overlay);
    }

    function render() {
      const items     = Cart.items;
      const totalQty  = Cart.count;
      const total     = (Cart.total || 0) / 100; // Shopify cents → EUR
      const FREE_SHIP = 75;
      const progress  = Math.min(100, (total / FREE_SHIP) * 100);
      const remaining = Math.max(0, FREE_SHIP - total);
      const cartUrl   = (window.routes && window.routes.cart_url) || '/cart';

      if (items.length === 0) {
        dropdown.innerHTML = `
          <div class="cart-dropdown-header">
            <span>Winkelwagen</span>
            <button class="close" aria-label="Sluit">&times;</button>
          </div>
          <div class="cart-empty">
            <div class="icon">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            </div>
            <div class="title">Je winkelwagen is leeg</div>
            <div class="sub">Begin met shoppen om hier producten te zien.</div>
            <a href="/collections/all" class="btn btn-orange">Naar de winkel</a>
          </div>`;
      } else {
        dropdown.innerHTML = `
          <div class="cart-dropdown-header">
            <span>Winkelwagen (${totalQty})</span>
            <button class="close" aria-label="Sluit">&times;</button>
          </div>
          <div class="cart-dropdown-items">
            ${items.map((item, i) => {
              const linePrice = (item.final_line_price || item.line_price || (item.price * item.quantity)) / 100;
              const lineNumber = i + 1; // Shopify lines zijn 1-based
              return `
                <div class="cart-item">
                  <div class="cart-item-img"><img src="${item.image || ''}" alt=""></div>
                  <div class="cart-item-info">
                    <div class="cart-item-brand">${item.vendor || ''} ${item.sku ? '· ' + item.sku : ''}</div>
                    <a href="${item.url}" class="cart-item-name">${item.product_title || item.title}</a>
                    <div class="cart-item-bottom">
                      <div class="cart-qty">
                        <button data-act="dec" data-line="${lineNumber}" data-qty="${item.quantity}">−</button>
                        <span>${item.quantity}</span>
                        <button data-act="inc" data-line="${lineNumber}" data-qty="${item.quantity}">+</button>
                      </div>
                      <div class="cart-item-price">${fmtPrice(linePrice)}</div>
                    </div>
                    <button data-act="rm" data-line="${lineNumber}" class="cart-item-remove">Verwijderen</button>
                  </div>
                </div>`;
            }).join('')}
          </div>
          <div class="cart-dropdown-footer">
            <div class="cart-total-row">
              <span>Subtotaal</span>
              <span class="price">${fmtPrice(total)}</span>
            </div>
            <div class="cart-actions">
              <a href="${cartUrl}" class="btn btn-outline">Bekijk wagen</a>
              <a href="/checkout" class="btn btn-orange">Afrekenen →</a>
            </div>
          </div>`;
      }

      // bind buttons → echte Shopify cart calls
      $('.close', dropdown)?.addEventListener('click', hide);
      $$('button[data-act]', dropdown).forEach(b => {
        b.addEventListener('click', async () => {
          const line = parseInt(b.dataset.line, 10);
          const curQty = parseInt(b.dataset.qty || '0', 10);
          let newQty;
          if (b.dataset.act === 'inc') newQty = curQty + 1;
          else if (b.dataset.act === 'dec') newQty = Math.max(0, curQty - 1);
          else if (b.dataset.act === 'rm') newQty = 0;
          else return;
          b.disabled = true;
          try {
            await Cart.changeLine(line, newQty);
            render();
            if (b.dataset.act === 'rm') toast('Verwijderd uit winkelwagen', { type: 'info' });
          } catch (e) { toast('Update mislukt', { type: 'error' }); }
          finally { b.disabled = false; }
        });
      });
    }

    function show() { render(); dropdown.classList.add('show'); overlay.classList.add('show'); }
    function hide() { dropdown.classList.remove('show'); overlay.classList.remove('show'); }
    function tg()   { dropdown.classList.contains('show') ? hide() : show(); }

    /* Click op cart-icoon → toggle (mobile + desktop) */
    toggle.addEventListener('click', e => {
      e.preventDefault();
      tg();
    });

    /* Hover op cart-icoon (desktop) → opent dropdown.
       Sluit met delay zodat muis tijd heeft om naar dropdown te bewegen. */
    let hoverTimer = null;
    function clearHover () { if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; } }
    toggle.addEventListener('mouseenter', () => { clearHover(); show(); });
    toggle.addEventListener('mouseleave', () => { hoverTimer = setTimeout(hide, 300); });
    dropdown.addEventListener('mouseenter', clearHover);
    dropdown.addEventListener('mouseleave', () => { hoverTimer = setTimeout(hide, 300); });

    overlay.addEventListener('click', hide);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') hide(); });

    // Re-render telkens als de cart verandert
    Cart.on(() => { if (dropdown.classList.contains('show')) render(); });

    // Eerste fetch om badge te updaten
    Cart.fetch();
  }


  /* ============================ HERO CAROUSEL ============================ */
  function initHeroCarousel() {
    const carousel = document.querySelector('.hero-carousel');
    if (!carousel) return;
    const slides = $$('.hero-slide', carousel);
    if (slides.length < 2) return;

    const dotsWrap = $('.hero-dots', carousel);
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'hero-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Ga naar slide ' + (i + 1));
      dot.addEventListener('click', e => { e.preventDefault(); goTo(i); });
      dotsWrap.appendChild(dot);
    });
    const dots = $$('.hero-dot', dotsWrap);
    const curEl = $('[data-slide-current]', carousel);

    let current = 0;
    const total = slides.length;

    function goTo(idx, manual = false) {
      current = ((idx % total) + total) % total;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      if (curEl) curEl.textContent = current + 1;
      if (manual) restart();
    }

    const prev = e => { e?.preventDefault(); goTo(current - 1, true); };
    const next = e => { e?.preventDefault(); goTo(current + 1, true); };

    $('.hero-arrow.prev', carousel)?.addEventListener('click', prev);
    $('.hero-arrow.next', carousel)?.addEventListener('click', next);

    // Autoplay
    const delay = parseInt(carousel.dataset.autoplay, 10) || 5000;
    let timer = setInterval(() => goTo(current + 1), delay);
    function restart() { clearInterval(timer); timer = setInterval(() => goTo(current + 1), delay); }
    carousel.addEventListener('mouseenter', () => clearInterval(timer));
    carousel.addEventListener('mouseleave', restart);

    // Swipe support
    let touchX = 0;
    carousel.addEventListener('touchstart', e => touchX = e.touches[0].clientX, { passive: true });
    carousel.addEventListener('touchend',   e => {
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) (dx > 0 ? prev : next)();
    });

    // Keyboard
    carousel.setAttribute('tabindex', '0');
    carousel.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  prev(e);
      if (e.key === 'ArrowRight') next(e);
    });
  }

  /* ============================ CAROUSEL (optioneel) ============================ */
  function initCarousels() {
    $$('.scroll-x').forEach(scroller => {
      const wrap = scroller.parentElement;
      if (!wrap || wrap.classList.contains('carousel-wrap')) return;
      wrap.classList.add('carousel-wrap');
      const prev = document.createElement('button');
      const next = document.createElement('button');
      prev.className = 'carousel-arrow prev'; prev.innerHTML = '←'; prev.setAttribute('aria-label','Vorige');
      next.className = 'carousel-arrow next'; next.innerHTML = '→'; next.setAttribute('aria-label','Volgende');
      wrap.appendChild(prev); wrap.appendChild(next);
      prev.addEventListener('click', () => scroller.scrollBy({ left: -300, behavior: 'smooth' }));
      next.addEventListener('click', () => scroller.scrollBy({ left:  300, behavior: 'smooth' }));
    });
  }

  /* ============================ CART PAGE (winkelwagen.html) ============================ */
  function initCartPage() {
    const root = $('#cart-page-root');
    if (!root) return;

    function render() {
      const items = Cart.get();
      const subtotal = items.reduce((s, i) => s + i.price * (i.qty || 1), 0);
      const totalQty = items.reduce((s, i) => s + (i.qty || 1), 0);
      const FREE = 75;
      const remaining = Math.max(0, FREE - subtotal);
      const shipping = subtotal >= FREE || subtotal === 0 ? 0 : 4.95;
      const total = subtotal + shipping;

      // Counter
      const lc = $('[data-cart-line-count]');
      if (lc) lc.textContent = totalQty;

      if (items.length === 0) {
        root.innerHTML = `
          <div class="bg-os-cream rounded-3xl p-12 text-center max-w-2xl mx-auto">
            <div class="w-20 h-20 rounded-full bg-white text-os-orange mx-auto mb-5 flex items-center justify-center">
              <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            </div>
            <h2 class="font-display text-3xl mb-3">Je winkelwagen is leeg</h2>
            <p class="text-os-navy/70 mb-6">Voeg producten toe en kom hier terug om af te rekenen.</p>
            <div class="flex flex-wrap justify-center gap-3">
              <a href="categorie.html" class="btn btn-orange">Naar de winkel</a>
              <a href="aanbieding.html" class="btn btn-outline">Bekijk aanbiedingen</a>
            </div>
          </div>`;
        return;
      }

      root.innerHTML = `
        <div class="grid lg:grid-cols-12 gap-10">
          <div class="lg:col-span-8 space-y-4">
            <div class="bg-os-cream rounded-2xl p-4 flex items-center justify-between text-sm">
              <span class="font-bold">${totalQty} ${totalQty === 1 ? 'artikel' : 'artikelen'}</span>
              <button id="cart-clear" class="text-os-grey underline hover:text-os-orange">Wagen leegmaken</button>
            </div>

            ${items.map((item, i) => `
              <div class="bg-white border border-os-line rounded-2xl p-5 flex gap-5 items-start">
                <div class="w-24 h-24 bg-os-cream rounded-xl p-2 flex-shrink-0 flex items-center justify-center">
                  <img src="${item.img}" alt="" class="max-w-full max-h-full object-contain">
                </div>
                <div class="flex-1 min-w-0">
                  <div class="text-xs text-os-grey font-bold uppercase tracking-wider">${item.brand || 'Speelgoed'} · ${item.sku || ''}</div>
                  <a href="product.html" class="font-bold text-base hover:text-os-orange block mt-1">${item.name}</a>
                  <div class="flex items-center gap-2 mt-2 text-xs text-os-grey">
                    <span class="flex items-center gap-1 text-green-600 font-bold"><span class="w-1.5 h-1.5 rounded-full bg-green-500"></span> Op voorraad</span>
                  </div>
                </div>
                <div class="flex flex-col items-end gap-3">
                  <div class="cart-qty">
                    <button data-act="dec" data-idx="${i}">−</button>
                    <span>${item.qty || 1}</span>
                    <button data-act="inc" data-idx="${i}">+</button>
                  </div>
                  <div class="font-display text-xl text-os-orange">${fmtPrice(item.price * (item.qty || 1))}</div>
                  <button data-act="rm" data-idx="${i}" class="text-xs text-os-grey underline hover:text-os-orange">Verwijder</button>
                </div>
              </div>`).join('')}

            <div class="bg-os-cream rounded-2xl p-5 flex items-center gap-4 mt-2">
              <span class="text-2xl">🎁</span>
              <div class="flex-1">
                <div class="font-bold text-sm">Cadeauverpakking?</div>
                <div class="text-xs text-os-grey">We pakken 'm in OSTOYS-papier en kunnen een kaartje meesturen.</div>
              </div>
              <label class="flex items-center gap-2 text-sm cursor-pointer">
                <input type="checkbox" class="accent-os-orange w-5 h-5"> + € 3,95
              </label>
            </div>

            <a href="categorie.html" class="block text-center text-sm font-bold text-os-grey hover:text-os-orange mt-4">← Verder shoppen</a>
          </div>

          <aside class="lg:col-span-4">
            <div class="lg:sticky lg:top-28 bg-os-cream rounded-3xl p-7">
              <div class="font-display text-xl mb-5">Besteloverzicht</div>


              <div class="space-y-2 text-sm">
                <div class="flex justify-between"><span class="text-os-grey">Subtotaal (${totalQty})</span><span class="font-bold">${fmtPrice(subtotal)}</span></div>
                <div class="flex justify-between"><span class="text-os-grey">Verzending</span><span class="font-bold ${shipping === 0 ? 'text-green-600' : ''}">${shipping === 0 ? 'Gratis' : fmtPrice(shipping)}</span></div>
              </div>

              <div class="pt-4 mt-4 border-t border-os-line flex items-baseline justify-between">
                <span class="font-display text-lg">Totaal incl. btw</span>
                <span class="font-display text-3xl text-os-orange">${fmtPrice(total)}</span>
              </div>

              <a href="afrekenen.html" class="btn btn-orange w-full mt-6 h-14 text-base">
                Naar afrekenen
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </a>

              <details class="mt-5">
                <summary class="text-sm font-bold cursor-pointer hover:text-os-orange">+ Kortingscode toevoegen</summary>
                <div class="mt-3 flex gap-2">
                  <input type="text" placeholder="BV. WELKOM5" class="flex-1 h-11 px-4 bg-white rounded-full text-sm focus:outline-none">
                  <button class="btn btn-navy text-sm">Toepassen</button>
                </div>
              </details>

              <div class="mt-6 pt-5 border-t border-os-line space-y-2 text-xs">
                <div class="flex items-center gap-2"><span class="text-os-orange">✓</span> 30 dagen niet-goed-geld-terug</div>
                <div class="flex items-center gap-2"><span class="text-os-orange">✓</span> Officieel dealer · fabrieksgarantie</div>
                <div class="flex items-center gap-2"><span class="text-os-orange">✓</span> Beveiligd betalen via Mollie</div>
              </div>

              <div class="mt-5 flex flex-wrap gap-2 justify-center">
                <span class="px-2 py-1 bg-white rounded text-[10px] font-bold">iDEAL</span>
                <span class="px-2 py-1 bg-white rounded text-[10px] font-bold">Bancontact</span>
                <span class="px-2 py-1 bg-white rounded text-[10px] font-bold">PayPal</span>
                <span class="px-2 py-1 bg-white rounded text-[10px] font-bold">Klarna</span>
                <span class="px-2 py-1 bg-white rounded text-[10px] font-bold">VISA</span>
                <span class="px-2 py-1 bg-white rounded text-[10px] font-bold">MC</span>
              </div>
            </div>
          </aside>
        </div>`;

      // bind acties
      $$('button[data-act]', root).forEach(b => {
        b.addEventListener('click', () => {
          const idx = parseInt(b.dataset.idx, 10);
          const list = Cart.get();
          if (!list[idx]) return;
          const item = list[idx];
          if (b.dataset.act === 'inc') item.qty = (item.qty || 1) + 1;
          if (b.dataset.act === 'dec') item.qty = Math.max(0, (item.qty || 1) - 1);
          if (b.dataset.act === 'rm' || item.qty === 0) {
            list.splice(idx, 1);
            if (b.dataset.act === 'rm') toast(`${item.name} verwijderd`, { type: 'info' });
          }
          Cart.set(list);
          render();
        });
      });
      $('#cart-clear', root)?.addEventListener('click', () => {
        if (confirm('Weet je zeker dat je de hele wagen wil leegmaken?')) {
          Cart.set([]);
          toast('Winkelwagen geleegd', { type: 'info' });
          render();
        }
      });
    }
    render();
  }

  /* ============================ CHECKOUT PAGE (afrekenen.html) ============================ */
  function initCheckoutPage() {
    const summary = $('#checkout-summary');
    const form = $('#checkout-form');
    if (!summary || !form) return;

    function render() {
      const items = Cart.get();
      const subtotal = items.reduce((s, i) => s + i.price * (i.qty || 1), 0);
      const totalQty = items.reduce((s, i) => s + (i.qty || 1), 0);
      const shipping = subtotal >= 75 || subtotal === 0 ? 0 : 4.95;
      const total = subtotal + shipping;
      const btw = total * 0.21 / 1.21;

      summary.innerHTML = `
        <div class="bg-os-cream rounded-3xl p-7">
          <div class="font-display text-xl mb-5">Jouw bestelling (${totalQty})</div>

          ${items.length === 0 ? `
            <div class="text-center py-6 text-os-grey">
              <div class="text-sm">Je winkelwagen is leeg.</div>
              <a href="categorie.html" class="btn btn-orange mt-4 text-sm">Naar de winkel</a>
            </div>
          ` : `
            <div class="space-y-3 max-h-[280px] overflow-y-auto pr-2">
              ${items.map(item => `
                <div class="flex gap-3 items-start">
                  <div class="relative w-16 h-16 bg-white rounded-xl p-1.5 flex-shrink-0 flex items-center justify-center">
                    <img src="${item.img}" alt="" class="max-w-full max-h-full object-contain">
                    <span class="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-os-navy text-white text-[10px] font-bold flex items-center justify-center">${item.qty || 1}</span>
                  </div>
                  <div class="flex-1 min-w-0">
                    <div class="font-bold text-sm leading-tight">${item.name}</div>
                    <div class="text-xs text-os-grey mt-0.5">${item.brand || ''} · ${item.sku || ''}</div>
                  </div>
                  <div class="font-display text-sm text-os-orange flex-shrink-0">${fmtPrice(item.price * (item.qty || 1))}</div>
                </div>`).join('')}
            </div>

            <details class="mt-5">
              <summary class="text-sm font-bold cursor-pointer">+ Kortingscode</summary>
              <div class="mt-3 flex gap-2">
                <input type="text" placeholder="BV. WELKOM5" class="flex-1 h-10 px-3 bg-white rounded-full text-sm">
                <button type="button" class="btn btn-navy text-xs">OK</button>
              </div>
            </details>

            <div class="space-y-2 text-sm mt-5 pt-5 border-t border-os-line">
              <div class="flex justify-between"><span class="text-os-grey">Subtotaal</span><span class="font-bold">${fmtPrice(subtotal)}</span></div>
              <div class="flex justify-between"><span class="text-os-grey">Verzending</span><span class="font-bold ${shipping === 0 ? 'text-green-600' : ''}">${shipping === 0 ? 'Gratis' : fmtPrice(shipping)}</span></div>
              <div class="flex justify-between text-xs"><span class="text-os-grey">Waarvan btw (21%)</span><span>${fmtPrice(btw)}</span></div>
            </div>
            <div class="pt-4 mt-4 border-t border-os-line flex items-baseline justify-between">
              <span class="font-display text-lg">Totaal</span>
              <span class="font-display text-3xl text-os-orange">${fmtPrice(total)}</span>
            </div>
          `}
        </div>

        <div class="mt-5 bg-white border border-os-line rounded-2xl p-5 space-y-3 text-sm">
          <div class="flex items-center gap-3"><span class="w-8 h-8 rounded-full bg-os-cream text-os-orange flex items-center justify-center">🔒</span><div><strong>SSL-beveiligd</strong><div class="text-xs text-os-grey">Mollie betaalverwerking</div></div></div>
          <div class="flex items-center gap-3"><span class="w-8 h-8 rounded-full bg-os-cream text-os-orange flex items-center justify-center">↩</span><div><strong>30 dagen retour</strong><div class="text-xs text-os-grey">Niet goed = geld terug</div></div></div>
          <div class="flex items-center gap-3"><span class="w-8 h-8 rounded-full bg-os-cream text-os-orange flex items-center justify-center">📞</span><div><strong>Hulp nodig?</strong><div class="text-xs text-os-grey">Bel 0317 - 613 332</div></div></div>
        </div>`;

      $('#checkout-total-btn').textContent = fmtPrice(total);
    }
    render();

    // Re-render bij eventuele cart wijziging
    const origSet = Cart.set.bind(Cart);
    Cart.set = function(items) { origSet(items); render(); };

    form.addEventListener('submit', e => {
      e.preventDefault();
      const items = Cart.get();
      if (items.length === 0) {
        toast('Je winkelwagen is leeg', { type: 'error' });
        return;
      }
      // Bewaar bestelling voor bedankt.html
      const subtotal = items.reduce((s, i) => s + i.price * (i.qty || 1), 0);
      const order = {
        id: 'OS-2026-' + String(Math.floor(Math.random() * 89999) + 10000),
        email: form.querySelector('input[type="email"]').value,
        items: items,
        subtotal: subtotal,
        total: subtotal + (subtotal >= 75 ? 0 : 4.95),
        payment: form.querySelector('input[name="pay"]:checked')?.value || 'iDEAL',
        date: new Date().toISOString()
      };
      localStorage.setItem('os-last-order', JSON.stringify(order));
      window.location.href = 'bedankt.html';
    });
  }

  /* ============================ CONFIRM PAGE (bedankt.html) ============================ */
  function initConfirmPage() {
    if (!$('[data-order-id]')) return;

    let order;
    try { order = JSON.parse(localStorage.getItem('os-last-order') || 'null'); }
    catch { order = null; }

    if (!order) {
      // Demo: laat default state met dummies
      order = {
        id: 'OS-2026-' + String(Math.floor(Math.random() * 89999) + 10000),
        email: 'voorbeeld@email.nl',
        items: [
          { name: 'CAT graafmachine 1:16', brand: 'Bruder', sku: 'U02483', price: 54.76, qty: 1, img: 'images/products/25855-7511-home.jpg' },
          { name: 'CAT Bulldozer 1:16', brand: 'Bruder', sku: 'U02422', price: 30.75, qty: 1, img: 'images/products/25816-7443-home.jpg' }
        ],
        subtotal: 85.51,
        total: 85.51,
        payment: 'iDEAL'
      };
    }

    $$('[data-order-id], [data-order-id-small]').forEach(el => el.textContent = '#' + order.id);
    $('[data-order-email]')?.replaceWith(...createEmailNode(order.email));
    $('[data-order-subtotal]').textContent = fmtPrice(order.subtotal);
    $('[data-order-btw]').textContent = fmtPrice(order.total * 0.21 / 1.21);
    $('[data-order-total]').textContent = fmtPrice(order.total);

    const paymentMap = {
      ideal: 'iDEAL · betaald', bancontact: 'Bancontact · betaald',
      paypal: 'PayPal · betaald', klarna: 'Klarna · achteraf',
      creditcard: 'Creditcard · betaald', invoice: 'Op factuur'
    };
    const pay = $('[data-order-payment]');
    if (pay) pay.textContent = paymentMap[order.payment] || order.payment;

    // Levertijd
    const tomorrow = new Date(); tomorrow.setDate(tomorrow.getDate() + 1);
    const dd = $('[data-delivery-date]');
    if (dd) dd.textContent = tomorrow.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' }) + ' tussen 9 — 21u';

    // Items
    const list = $('#confirm-items');
    if (list) {
      list.innerHTML = order.items.map(item => `
        <div class="flex gap-3 items-start">
          <div class="relative w-14 h-14 bg-white rounded-xl p-1.5 flex-shrink-0 flex items-center justify-center">
            <img src="${item.img}" alt="" class="max-w-full max-h-full object-contain">
            <span class="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-os-navy text-white text-[10px] font-bold flex items-center justify-center">${item.qty || 1}</span>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-bold text-sm leading-tight">${item.name}</div>
            <div class="text-xs text-os-grey mt-0.5">${item.brand || ''} · ${item.sku || ''}</div>
          </div>
          <div class="font-display text-sm text-os-orange">${fmtPrice(item.price * (item.qty || 1))}</div>
        </div>`).join('');
    }

    // Maak cart leeg (na succesvolle bestelling)
    Cart.set([]);
  }

  function createEmailNode(email) {
    const strong = document.createElement('strong');
    strong.setAttribute('data-order-email', '');
    strong.textContent = email;
    return [strong];
  }

  /* ============================ NEWSLETTER & CONTACT FORMS ============================ */
  function initForms() {
    $$('form').forEach(form => {
      if (form.getAttribute('role') === 'search') return;
      form.addEventListener('submit', e => {
        e.preventDefault();
        const email = form.querySelector('input[type="email"]')?.value;
        if (form.querySelector('button')?.textContent.match(/inschrijven/i)) {
          toast(`Bedankt! Bevestigingsmail naar ${email || 'jouw adres'} verstuurd.`);
          form.reset();
        } else if (form.querySelector('textarea')) {
          toast('Bericht verstuurd — we reageren binnen 24 uur.');
          form.reset();
        } else {
          toast('Verstuurd!', { type: 'info' });
        }
      });
    });
  }

  /* ============================ INIT ============================ */
  document.addEventListener('DOMContentLoaded', () => {
    normalizeHeaderActions();
    initPaymentLogos();
    Cart.updateUI();
    Wishlist.updateUI();
    initSearch();
    initCartDropdown();
    initCartButtons();
    initWishlistButtons();
    initWishlistDropdown();
    initGallery();
    initFilters();
    initSort();
    initMobileFilterToggle();
    initQuantity();
    initMobileMenu();
    /* initMegaMenu() — verwijderd: mega-menu wordt nu server-side gerendered
       door snippets/mega-menu.liquid + header.liquid */
    initHeroCarousel();
    initCarousels();
    initCartPage();
    initCheckoutPage();
    initConfirmPage();
    initForms();
  });
})();
